fragment SubscriptionFragment on Subscription {
    unitAmount
    total
    stickerTotal
    unitAmountDisplay
    stickerUnitAmountDisplay
    totalDisplay
    stickerTotalDisplay
    planCode
    coupon {
        name
        code
        planCodes
        expiresAt
        appliedAt
        discountType
        discountAmount
        discountPercent
        displayInfo
    }
    product
    cycleText
    name
    nameDisplay
    currentTier
    quantity
    productQuantity
    billDate {
        timestamp
        humanShort
        humanDate
    }
    isFake
}
